import React from "react";

export default function Seventeen({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M239.42,299.62H60.58a19.39,19.39,0,0,1-19.36-19.36V91.42l1,0a19.68,19.68,0,0,0,0-39.34l-1,0V20.94C41.22,10.06,50.27.52,60.58.52H239.42c10.31,0,19.36,9.54,19.36,20.42V52h-1.2a19.7,19.7,0,0,0,0,39.39h1.19V280.26A19.39,19.39,0,0,1,239.42,299.62ZM43.34,93.46v186.8A17.25,17.25,0,0,0,60.58,297.5H239.42a17.25,17.25,0,0,0,17.24-17.24V93.51a21.81,21.81,0,0,1,0-43.58v-29c0-9.75-8.06-18.3-17.24-18.3H60.58c-9.18,0-17.24,8.55-17.24,18.3V50a21.79,21.79,0,0,1,0,43.47Z" />
      <path d="M225.62,72.63h-5.29V70.51h5.29Zm-10.58,0h-5.29V70.51H215Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0H178V70.51h5.29Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0h-5.28V70.51h5.28Zm-10.57,0H135.7V70.51H141Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0h-5.29V70.51h5.29Zm-10.58,0H104V70.51h5.29Zm-10.58,0H93.38V70.51h5.29Zm-10.58,0H82.8V70.51h5.29Zm-10.58,0H72.22V70.51h5.29Z" />
      {children}
    </svg>
  );
}
